<template>
  <section class="py-10">
    <div class="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
      <h2 v-if="heading" class="text-2xl font-semibold tracking-[-0.02em] text-ink md:text-3xl">{{ heading }}</h2>
      <p v-if="subheading" class="mt-2 text-ink-2">{{ subheading }}</p>
      <div class="mt-6 overflow-x-auto rounded-2xl border border-line bg-surface">
        <table class="w-full text-left">
          <thead class="bg-wash">
            <tr>
              <th class="sticky left-0 z-10 bg-wash px-4 py-3 text-sm font-semibold text-ink">
                Feature
              </th>
              <th
                v-for="(col, idx) in products"
                :key="idx"
                class="whitespace-nowrap px-4 py-3 text-sm font-semibold"
                :class="col.highlight ? 'bg-accent-tint text-accent' : 'text-ink'"
              >
                {{ col.name }}
                <div v-if="col.tagline" class="mt-0.5 text-xs font-normal text-ink-4">{{ col.tagline }}</div>
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-line">
            <tr v-for="(row, rIdx) in rows" :key="rIdx">
              <td class="sticky left-0 z-10 bg-surface px-4 py-3 text-sm font-medium text-ink">
                {{ row.feature }}
              </td>
              <td
                v-for="(col, cIdx) in products"
                :key="cIdx"
                class="px-4 py-3 text-sm text-ink-2"
                :class="{ 'bg-accent-tint/40': col.highlight }"
              >
                <span v-if="row.values[cIdx] === true" class="font-semibold text-success">✓</span>
                <span v-else-if="row.values[cIdx] === false" class="text-ink-4">—</span>
                <span v-else>{{ row.values[cIdx] }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>


<script setup lang="ts">
export interface ComparisonProduct {
  name: string
  tagline?: string
  highlight?: boolean
}

export interface ComparisonRow {
  feature: string
  values: Array<string | number | boolean>
}

defineProps<{
  heading?: string
  subheading?: string
  products: ComparisonProduct[]
  rows: ComparisonRow[]
}>()
</script>
